import React, {Component} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const messages = defineMessages({
  welcome: {
    id: 'home.welcome',
    defaultMessage: 'Welcome to the Ignite Sales Customer Portal',
    description: 'A welcome message for the user when they visit the home page.'
  }
});

class UnauthenticatedHome extends Component {

  render() {
    return <section className='user-info'>
      <h1>
        <FormattedMessage { ...messages.welcome } />
      </h1>
      <p>
        Please <Link to='/account/login'>click here</Link> to log in.
      </p>
    </section>;
  }
}

export default UnauthenticatedHome;



// WEBPACK FOOTER //
// ./src/pages/UnauthenticatedHome.js